var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apresentacao'),_c('missao'),_c('contato'),_c('tutorial'),_c('lojas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }